import axios from "axios";
import axiosRetry from "axios-retry";
import { ensureValidToken } from "./tokenRefresh";

const Api = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL?.trim() || "http://localhost:3000"}/`,
});

Api.interceptors.request.use(
  async (config) => {
    // Verifica e renova o token se necessário antes de cada requisição
    await ensureValidToken();

    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosRetry(Api, {
  retries: 3,
  retryDelay: (retryCount) => {
    return retryCount * 1000;
  },
  retryCondition: (error) => {
    return (
      axiosRetry.isNetworkOrIdempotentRequestError(error) ||
      error.response?.status >= 500
    );
  },
});

export default Api;
